<template>
  <v-row dense>
    <v-col cols="5">
      <div class="file-upload-title">{{ title }}</div>
    </v-col>
    <v-col
      class="d-flex align-center"
      cols="auto"
      style="flex: 0 0 auto; width: auto; min-width: 0"
    >
      <label :for="fileInputId">
        <input
          :id="fileInputId"
          style="display: none"
          type="file"
          :accept="fileExtensions || defaultFileExtensions"
          @change="handleFileChange($event)"
        />
      </label>
      <cs-button
        :id="uploadButtonId"
        primary
        left-icon="mdi-upload"
        label="Upload"
        :loading="loading"
        :disabled="loading || disabled"
        @click="onUploadButtonClick()"
      />
    </v-col>
    <v-col class="d-flex align-center">
      <span v-if="showErrorMessage" class="file-upload-error">{{ errorMessage }}</span>
      <template v-else>
        <slot name="custom-info" :file="uploadedFile">
          <span class="file-upload-filename">{{ uploadedFile.filename }}</span>
        </slot>
      </template>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    title: { type: String, required: true },
    id: { type: String, required: true },
    fileExtensions: { type: String, required: true },
    loading: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ['file-changed'],
  data() {
    return {
      defaultFileExtensions: '.csv',
      fileChanged: false,
      showErrorMessage: false,
      errorMessage: '',
      uploadedFile: { file: null, filename: null }
    };
  },
  computed: {
    uploadButtonId() {
      return this.id + '_uploadBtn';
    },
    fileInputId() {
      return this.id + '_fileInput';
    }
  },
  methods: {
    onUploadButtonClick() {
      document.getElementById(this.fileInputId).click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const filename = file.name;
      const extensionType = filename.split('.').pop();
      // const fileType = file.type;

      if (this.fileExtensions.indexOf(extensionType) < 0) {
        this.errorMessage = `Please select a ${this.fileExtensions} file.`;
        this.showErrorMessage = true;
        this.uploadedFile.filename = filename;
        event.target.value = '';
        return;
      }
      this.showErrorMessage = false;
      this.uploadedFile.file = file;
      this.uploadedFile.filename = filename;
      this.fileChanged = true;
      this.$emit('file-changed', this.id, this.uploadedFile);
      // Reset input to allow uploading the same file again
      event.target.value = '';
    }
  }
};
</script>

<style scoped>
.file-upload-title {
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}
.file-upload-error {
  color: red;
}
.file-upload-filename {
  font-size: 14px;
  color: black;
}
</style>
